import React from "react";
import { Alert } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useAppBootstrap } from "../../providers/AppBootstrapProvider";
import { useAccountReadiness } from "../../providers/AccountReadinessProvider";
import { EmailVerificationNotice } from "../../components/auth/EmailVerificationNotice";
export { EmailVerificationNotice } from "../../components/auth/EmailVerificationNotice";

const AccountNotices = () => {
  const { currentUser } = useAppBootstrap();
  const readiness = useAccountReadiness();
  const location = useLocation();
  if (!currentUser || ["/finish-signup", "/register"].includes(location.pathname)) return null;
  if (readiness.status === "incomplete") return <Alert variant="warning" className="account-setup-notice">
    <Link to="/finish-signup" state={{ from: location.pathname + location.search }}>Finish account setup</Link>
  </Alert>;
  if (readiness.status !== "complete" || /^\/(login|signup|forgot-password)(\/|$)/.test(location.pathname)) return null;
  return <EmailVerificationNotice key={currentUser.uid} />;
};

export default AccountNotices;
